const ADDR_RE = /^0x[a-fA-F0-9]{40}$/;

function pick(raw, key, index) {
  if (raw && typeof raw === "object" && raw[key] !== undefined && raw[key] !== null) {
    return raw[key];
  }
  if (Array.isArray(raw) && index < raw.length) return raw[index];
  return undefined;
}

function looksLikeMetadataUri(value) {
  const s = String(value || "").trim();
  return /^https?:\/\//i.test(s) || s.startsWith("ipfs://");
}

function usesTwelveFieldLayout(raw) {
  if (raw && raw.cardToken !== undefined && raw.payToken !== undefined) {
    return true;
  }
  const len = Array.isArray(raw) ? raw.length : 0;
  if (len >= 12) return true;
  if (len === 11) return false;
  const payAt2 = pick(raw, "payToken", 2);
  if (payAt2 !== undefined && ADDR_RE.test(String(payAt2))) return true;
  const payAt1 = pick(raw, "payToken", 1);
  if (payAt1 !== undefined && ADDR_RE.test(String(payAt1))) return false;
  return true;
}

/** 链上 CardInfo（ABI 含 cardToken + admin + … + cardUri，共 12 字段） */
function fromChainRow(raw) {
  if (usesTwelveFieldLayout(raw)) {
    const cardToken = pick(raw, "cardToken", 0);
    return {
      cardToken: cardToken || "",
      admin: pick(raw, "admin", 1),
      payToken: pick(raw, "payToken", 2),
      supply: pick(raw, "supply", 3),
      collectAmount: pick(raw, "collectAmount", 4),
      collectGoal: pick(raw, "collectGoal", 5),
      initPrice: pick(raw, "initPrice", 6),
      increment: pick(raw, "increment", 7),
      currentPrice: pick(raw, "currentPrice", 8),
      nextTokenId: pick(raw, "nextTokenId", 9),
      isFinish: pick(raw, "isFinish", 10),
      cardUri: pick(raw, "cardUri", 11) || "",
    };
  }

  return {
    cardToken: "",
    admin: pick(raw, "admin", 0),
    payToken: pick(raw, "payToken", 1),
    supply: pick(raw, "supply", 2),
    collectAmount: pick(raw, "collectAmount", 3),
    collectGoal: pick(raw, "collectGoal", 4),
    initPrice: pick(raw, "initPrice", 5),
    increment: pick(raw, "increment", 6),
    currentPrice: pick(raw, "currentPrice", 7),
    nextTokenId: pick(raw, "nextTokenId", 8),
    isFinish: pick(raw, "isFinish", 9),
    cardUri: pick(raw, "cardUri", 10) || "",
  };
}

/** 解析 getAllCards / cardInfo 返回的 CardInfo 结构 */
export function normalizeCardInfo(raw) {
  if (!raw) return raw;
  if (typeof raw !== "object") return raw;
  return fromChainRow(raw);
}

export function metadataUriFromCardInfo(info) {
  if (!info) return "";
  const uri = String(info.cardUri || "").trim();
  if (uri) return uri;
  const token = info.cardToken;
  if (looksLikeMetadataUri(token)) return String(token).trim();
  return "";
}

export function nftProxyFromCardInfo(info) {
  if (!info) return "";
  const token = String(info.cardToken || "").trim();
  return ADDR_RE.test(token) ? token : "";
}
